import pl from "@locales/autogenerate_modal/pl.json";
import en from "@locales/autogenerate_modal/en.json";

export default {
  pl: pl,
  en: en,
};
